/*
 * Welcome to your app's main JavaScript file!
 *
 * We recommend including the built version of this JavaScript file
 * (and its CSS file) in your base layout (base.html.twig).
 */

// any CSS you require will output into a single css file (app.css in this case)
import '../scss/desktop/desktop.scss';
import $ from 'jquery';
import 'jquery.scrollto';
import 'foundation-sites';
import 'motion-ui';
import 'select2';
import "inputmask";
import '../scss/app/cookies-message.min.css';
import './components/cookies-message.min';
import LightBox from 'lightbox2/dist/js/lightbox';
import {Cookie} from './helper/cookie';
import PartTabs from "./components/part_tabs";
import YandexMap from "./components/yandex.maps";
import CallbackForm from "./components/callback_form";
import FavItem from "./components/fav_item";
import FormValidation from "./components/validation";
import {Open_lines} from './components/open_lines';
import Search from './components/search/search';
import {Brand} from "./components/brand";
import {Location} from './components/location';
import {initUp} from "./helper/up";
import {Geo} from "js/utils/geo";

if (window.ymaps !== undefined) {
    window.ymaps.ready(function () {
        try {
            let map = new YandexMap('yndMap', window.city, 12, window);
            map.drawPlacemarks();
        } catch (e) {}
    });
}

$().ready(function () {
    $(document).foundation();
    let cookie = new Cookie();
    if (window.alert_message !== false) {
        $.CookiesMessage({
            messageText: window.alert_message,
            closeEnable: false,
            infoEnable: false,
            acceptText: "Закрыть",
            cookieExpire: 1
        });
    }
    FormValidation.oemSearchValidate();
    (new PartTabs()).event();
    new Brand();
    (new Location()).init();
    new Open_lines();
    new CallbackForm();
    (new FavItem()).event();
    (new Search()).event();
    initUp();
    init(cookie);
});

function init(cookie) {
    try {
        if (typeof location.hash !== 'undefined' && location.hash == '#cookie' && location.href.indexOf('personal-policy') !== -1) {
            let url = location.href.replace(location.hash, '');
            window.history.replaceState(null, null, url);
            let hash = 'cookie-block';
            if ($('#' + hash).length !== 0) {
                $('body').scrollTo('#' + hash, 100, {offset: - $('.header-block').height() - 20});
            }
        }
    } catch (e) {
        console.info(e);
    }

    // И.13435, Н.0000218736: гео-координаты для записи в статистику.
    Geo.geoCoords();

    $('button[data-action="confirm-cookie"]').on('click', function () {
        $(this).parent().parent().remove();
        cookie.setCookie('confirm-cookie', 1, {"max-age": 2592000});
    });

    $('.cookie a').on('click', function (e) {
        if (typeof location.hash !== 'undefined' && location.href.indexOf('personal-policy') !== -1) {
            e.preventDefault();
            let $this = $(e.target);
            let hash = $this.attr('href').split('#');
            if (hash.length !== 0 && hash[hash.length - 1] === 'cookie') {
                $('body').scrollTo('#cookie-block', 100, {offset: - $('.header-block').height() - 20});
            }
        }
    });

    $('.body').delegate('.b24-form-control-desc, .b24-form-field-agreement-link', 'click', function() {
        console.info('.b24-form-field-agreement-link:click');
        setTimeout(function () {
            let link = 'https://b24autotradesu2.bitrix24.site/crm_form_yu0w7/';
            let $blockTextAgreement = $('.b24-form').find('.b24-window').find('.b24-window-popup-body > div > div:first-child');
            $blockTextAgreement.html(
                $blockTextAgreement.html().replace(link, '<a href="' + link + '" target="_blank">' + link + '</a>')
            );
        }, 100);
    });

    $('#toolAction').on('click', function () {
        window.location = $(this).data('uri') + '/wiper/' + $('#wiperType').val() + '/' + $('#wiperLength').val();
    });

    $('button[data-action="hidden-message"]').on('click', function () {
        cookie.setCookie('hidden-message-' + $(this).data('id'), 1, {"max-age": 2592000});
    });

    let showClass = 'show';
    $('input').on('checkval', function () {
        let label = $(this).prev('label');
        if (this.value !== '') {
            label.addClass(showClass);
        } else {
            label.removeClass(showClass);
        }
    }).on('keyup', function () {
        $(this).trigger('checkval');
    });
    LightBox.option({
        albumLabel: 'Изображение %1 из %2'
    });
    $('[data-active-lightbox]').on('click', (e) => {
        let $c = $(e.currentTarget);
        let $ei = $('.extra-images', $c.parent());
        if ($ei.length > 0) {
            let $ai = $('a:first', $ei);
            $ai.trigger('click');
            e.stopPropagation();
            e.preventDefault();
        }
    });

    $('.select2').select2({theme: "bootstrap4"});
    $('#supplier').on('submit', function () {
        if (!grecaptcha.getResponse()) {
            alert('Вы не заполнили поле Я не робот!');
            return false; // возвращаем false и предотвращаем отправку формы
        }
    });

    let maxCount = 1000;

    $("#feedback-count").html(maxCount);

    $("#feedback-text").keyup(function () {
        let revText = this.value.length;

        if (this.value.length > maxCount) {
            this.value = this.value.substr(0, maxCount);
        }

        let cnt = (maxCount - revText);
        if (cnt <= 0) {
            $("#feedback-count").html('0');
        } else {
            $("#feedback-count").html(cnt);
        }
    });

    let $fa = $("[data-filter]");
    $fa.on('click', (e) => {
        let $a = $(e.currentTarget);
        if ($a.data('filter') !== "drop") {
            $('[data-filter="drop"]').addClass('hollow');
            $a.toggleClass('hollow');
        } else {
            $fa.addClass('hollow');
            $a.removeClass('hollow');
        }
        let all_h = true;
        $fa.each(function (el) {
            if (false === $(this).hasClass("hollow")) all_h = false;
        });
        if (all_h) $('[data-filter="drop"]').removeClass('hollow');

        if (false === $('[data-filter="drop"]').hasClass("hollow")) {
            $("section[data-filter-brand]").removeClass("d-none");
            $("[data-group-target]").removeClass("d-none");
            $(".related-button").removeClass("d-none");
            $(".component-button").removeClass("d-none");
            $(".related").addClass("d-none");
            $(".component").addClass("d-none");
            return;
        }

        $("[data-group-target]").addClass("d-none");
        $(".related-button").addClass("d-none");
        $(".component-button").addClass("d-none");

        $fa.each(function (el) {
            let $t = $(this);
            let brand = $t.data("filter");
            if ($t.hasClass("hollow")) {
                $('section[data-filter-brand="' + brand + '"]').addClass("d-none");
            } else $('section[data-filter-brand="' + brand + '"]').removeClass("d-none").each(function (el) {
                $('[data-group-target="' + $(this).data('parent-target') + '"]').removeClass('d-none');
            });
        })
    });

    $('.related-button').on('click', (e) => {
        let $c = $(e.currentTarget);
        $('.related').removeClass('d-none');
        $c.addClass('d-none');
    });

    $('.component-button').on('click', (e) => {
        let $c = $(e.currentTarget);
        $('.component').removeClass('d-none');
        $c.addClass("d-none");
    });
    $(".related").addClass("d-none");
    $(".component").addClass("d-none");

    let $window = $(window);
    let headerBlock = $('header .header-block');
    $window.on('scroll', () => {
        let scrollTop = $window.scrollTop();

        if (scrollTop > 0) {
            headerBlock.addClass('header-fixed')
        } else {
            headerBlock.removeClass('header-fixed')
        }
    });
    $window.trigger('scroll');
}
